import React from 'react';
import { Chip } from '@mui/material';
import { GridActionsCellItem, GridColDef } from '@mui/x-data-grid';
import CheckIcon from '@mui/icons-material/Check';
import PublishIcon from '@mui/icons-material/Publish';
import { FDataGrid } from '../grid';

type Props = {
  rows: any[];
  loading?: boolean;
  onValidate: (row: any) => void;
  onPublish: (row: any) => void;
};

class HistoricalImportGrid extends React.PureComponent<Props> {

  columns: GridColDef[] = [
    { field: 'sourcecode', headerName: 'Source', width: 130 },
    { field: 'scenariocode', headerName: 'Scenario', width: 140 },
    { field: 'filename', headerName: 'File', flex: 1, minWidth: 260 },
    { field: 'recordcount', headerName: 'Records', width: 110, type: 'number' },
    { field: 'errorcount', headerName: 'Errors', width: 100, type: 'number' },
    {
      field: 'status',
      headerName: 'Status',
      width: 110,
      renderCell: (p) => (
        <Chip
          size="small"
          label={p.value}
          color={Number(p.value) === 1 ? 'success' : 'warning'}
        />
      ),
    },
    { field: 'created', headerName: 'Created', width: 180 },
    {
      field: 'actions',
      type: 'actions',
      width: 100,
      getActions: (p) => [
        <GridActionsCellItem
          icon={<CheckIcon />}
          label="Validate"
          onClick={() => this.props.onValidate(p.row)}
        />,
        <GridActionsCellItem
          icon={<PublishIcon />}
          label="Publish"
          onClick={() => this.props.onPublish(p.row)}
        />,
      ],
    },
  ];

  getRowId = (r: any) => r.rid || r.recid || r.importid || r.id;

  render() {
    return (
      <FDataGrid
        title="Historical Data Imports"
        subtitle="Upload, validate and publish immutable facts before forecasting."
        rows={this.props.rows || []}
        columns={this.columns}
        loading={this.props.loading}
        height={420}
        showQuickFilter
        toolbarSx={{ backgroundColor: '#eaf2fb' }}
        getRowId={this.getRowId}
        pageSizeOptions={[10, 25, 50]}
      />
    );
  }
}

export default HistoricalImportGrid;
